<script>
export default {
	props: [ 'display', 'copyData' ],
	data() {
		return {
			showCopied: false,
		};
	},
	methods: {
		copyText(data) {
			this.showCopied = true;
			navigator.clipboard.writeText(data);
			setTimeout(() => {
				this.showCopied = false;
			}, 3000);
		},
	},
};
</script>

<template src="./RoCopy.html"></template>
<style src="./RoCopy.scss"></style>



// WEBPACK FOOTER //
// RoCopy.vue?ae2ad394